/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

module.exports = function(formData) {
  return $.soap({
    body: {
      SubmitEntity: {
        $xmlns: 'http://dobs.pa.gov/co/entity/bpm/1.0',
        EntityID: formData.id,
        Name: formData.name,
        EntityTypeID: formData.entityTypeId,
        OrganizationTypeID: formData.organizationTypeId,
        Website: formData.website,
        Address: {
          AddressLine1: formData.addressLine1,
          AddressLine2: formData.addressLine2,
          City: formData.city,
          State: formData.state,
          County: formData.county,
          PostalCode: formData.postalCode,
          Country: formData.country
        }
      }
    }
  });
};
